var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.73 1.40997L16.45 2.40997L11 6.45997L5.54995 2.36997L4.26995 1.36997C3.96841 1.12052 3.6003 0.965014 3.21124 0.922724C2.82218 0.880434 2.42926 0.953217 2.08116 1.13206C1.73306 1.3109 1.44508 1.58793 1.25289 1.92885C1.06071 2.26976 0.97276 2.65957 0.999952 3.04997V14.64C0.999952 15.0007 1.14324 15.3466 1.39829 15.6016C1.65334 15.8567 1.99926 16 2.35995 16H5.54995V8.27997L11 12.37L16.45 8.27997V16H19.64C20.0006 16 20.3466 15.8567 20.6016 15.6016C20.8567 15.3466 21 15.0007 21 14.64V3.04997C21.0187 2.66294 20.9247 2.27878 20.7292 1.9442C20.5337 1.60961 20.2453 1.33902 19.8989 1.1653C19.5525 0.991588 19.1632 0.922233 18.7781 0.965668C18.3931 1.0091 18.0289 1.16346 17.73 1.40997V1.40997Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.395bf747a025444b0869146d85fe16df.svg";
export { ForwardRef as ReactComponent };